// @flow
import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react'

import PropTypes from 'prop-types';
import md5 from 'blueimp-md5';
import { useForm, Controller } from "react-hook-form";

import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import SelMemberDialog from './SelMemberDialog';
import MsgDialog from './MsgDialog';
import Backdrop from '@mui/material/Backdrop';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import CircularProgress from '@mui/material/CircularProgress';
// import useImage from 'use-image';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';


import CssBaseline from '@mui/material/CssBaseline';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';

import { GlobalEvent, GlobalState } from './GlobalContext'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';

import GroupListTable from './GroupListTable';

export default function UserAddDialog(props) {

  const { sysID, open, onClose, userInfo, onUpdated } = props;

  const editMode = (props.editMode === true) || false;
  const isDomainUser = (props.isDomainUser === true) || false;

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [depts, setDepts] = useState([]);
  const [groups, setGroups] = useState([]);
  const [allUserGroups, setAllUserGroups] = useState([]);
  const [selectedRecs, setSelectedRecs] = useState([]);

  const DUMMY_PASSWORD = '27b786700fee4949ab4b16c7159bbea7';

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });
  }

  useEffect(async () => {

    if (open === true) {

      try {


        const vDepts = await DmsService.deptListGetPromise(gState.sessionID, sysID);
        // Add
        vDepts.splice(0, 0, {
          DeptCode: "0",
          DeptName: "[None]"
        });
        // console.log("vDepts", vDepts);

        const vUserGroups = await DmsService.getGroupsByUserPromise(gState.sessionID, sysID,
          userInfo?.userID || "");
        // console.log('useEffect ~ vUserGroups:', vUserGroups);
        setGroups(vUserGroups);


        setDepts(vDepts);

        // console.log("userInfo", userInfo);

        setValue("userID", userInfo?.userID || "");
        setValue("domain", userInfo?.domain || "");
        setValue("name", userInfo?.name || "");
        setValue("desc", userInfo?.desc || "");
        setValue("email", userInfo?.email || "");

        const vCode = userInfo?.deptCode || "";
        const vFindDept = depts.find(d => d.DeptCode == vCode);
        setValue("deptCode", vFindDept?.DeptCode || "0");

        setValue("dataAdmin", userInfo?.dataAdmin || false);
        setValue("securityAdmin", userInfo?.securityAdmin || false);
        setValue("disabled", userInfo?.disabled || false);



        if (editMode && !isDomainUser) {
          setValue("pwd", DUMMY_PASSWORD);
          setValue("confirmPwd", DUMMY_PASSWORD);
        } else {
          setValue("pwd", "");
          setValue("confirmPwd", "");
        }

      } catch (e) {
        onCatchPromiseError(e);
      }

    }

  }, [open])

  // Setup inital form values
  const defaultFormValues = {
    userID: "",
    pwd: "",
    confirmPwd: "",
    domain: "",
    name: "",
    desc: "",
    email: "",
    deptCode: "",
    dataAdmin: false,
    securityAdmin: false,
    disabled: false,
  }

  // React Hook the form
  const { control, handleSubmit, setValue, getValues, watch } = useForm({
    defaultValues: defaultFormValues
  });


  const onSubmit = async (data) => {
    // console.log("onSubmit", data);

    if (!isDomainUser && data.pwd != DUMMY_PASSWORD && data.pwd != data.confirmPwd) {
      setErrMsg('Passwords do not match!');
      setShowError(true);
      return
    }

    if (!isDomainUser && data.pwd != data.confirmPwd) {
      setErrMsg('Passwords do not match!');
      setShowError(true);
      return
    }

    // If password equal to DUMMY_PASSWORD, set it to empty string
    const vHashPwd = (data.pwd == DUMMY_PASSWORD ? '' : md5(data.pwd));
    // console.log("vHashPwd", vHashPwd);

    const vGrade =
      (data.dataAdmin === true ? DmsCommon.SystemAdminEnum.saData : 0) +
      (data.securityAdmin === true ? DmsCommon.SystemAdminEnum.saSecurity : 0);
    // console.log("vGrade", vGrade);

    setShowLoading(true);
    try {

      if (editMode === true) {
        await DmsService.memberEditPromise(gState.sessionID, sysID,
          data.userID,
          vHashPwd,
          data.name,
          data.email,
          data.deptCode,
          data.desc,
          vGrade,
          data.disabled,
        );

      } else {
        await DmsService.memberAddPromise(gState.sessionID, sysID,
          data.userID,
          vHashPwd,
          data.domain,
          isDomainUser,
          data.name,
          data.email,
          data.deptCode,
          data.desc,
          vGrade,
          data.disabled,
        );

      }

      // console.log('onSubmit ~ groups:', groups);
      const grpIDs = groups.map((item) => item.GroupID)
      // console.log('onSubmit ~ grpIDs:', grpIDs);

      await DmsService.memberUpdateUserGroupsPromise(gState.sessionID, sysID, data.userID, grpIDs);

      setShowLoading(false);

      onUpdated && onUpdated();

    } catch (e) {
      setShowLoading(false);

      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);
      onCatchPromiseError(e);

    }
  }

  const handleCloseClick = () => {
    onClose && onClose();
  }

  const submitBtnRef = useRef();

  const handleFormSubmit = () => {
    submitBtnRef?.current?.click();
  }

  const [openAddUserDialog, setOpenAddUserDialog] = useState(false);

  const handleSelectAddUsers = (aUsers, aGroups) => {
    // console.log("aUsers", aUsers);
    // console.log("aGroups", aGroups);

    let vSelUserGroups = aGroups.map(item => {
      return {
        GroupID: item.GroupID,
        Name: item.Name,
        Desc: item.Desc,
      }
    });

    // console.log('handleSelectAddUsers ~ groups:', groups);
    let vNewUserGroups = [...groups];


    vSelUserGroups.forEach((item) => {
      const vFoundGrp = vNewUserGroups.find(g => g.GroupID === item.GroupID);
      if (!vFoundGrp) {
        vNewUserGroups.push(item);
      }
    })

    // console.log('handleSelectAddUsers ~ vNewUserGroups:', vNewUserGroups);
    setGroups(vNewUserGroups);

    setOpenAddUserDialog(false);

  }



  const onSelectionChanged = (params) => {
    // console.log('Selection Changed', params);
    let nodes = params.api.getSelectedNodes();
    // console.log('Selected nodes', nodes);

    let selRecs = nodes.map(item => {
      return item.data
    });

    setSelectedRecs(selRecs);

  }


  const handleAddByUser = async () => {

    setShowLoading(true);

    try {

      const vAllUserGroups = await DmsService.getGroupsPromise(gState.sessionID, sysID);

      // console.log('vUsers', vUsers);
      // console.log('vAllUserGroupps', vAllUserGroups);

      setAllUserGroups(vAllUserGroups);


      setShowLoading(false);
      setOpenAddUserDialog(true);
    } catch (e) {
      setShowLoading(false);
      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);

      onCatchPromiseError(e);
    }


  };

  const handleRemove = () => {
    // console.log("handleRemove selectedRecs", selectedRecs);

    const vNewGroups = groups.filter(d => !selectedRecs.some(r => r.GroupID === d.GroupID));
    setGroups(vNewGroups);
    setSelectedRecs([]);

  }

  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };

  const compareStrInsensitive = (aStrA, aStrB) => {
    return aStrA.localeCompare(aStrB, undefined, { sensitivity: "base" })
  }

  const comparatorName = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Name, nodeB.data.Name)
  }

  const comparatorDesc = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Desc, nodeB.data.Desc)
  }

  const columnDefs = useMemo(() => [

    {
      field: 'Name', headerName: "Group Name", cellStyle: cellStyle, width: 100, flex: "1",
      headerCheckboxSelection: true, checkboxSelection: true,
      comparator: comparatorName,
    },
    { field: 'Desc', headerName: "Description", cellStyle: cellStyle, width: 100, flex: "1", comparator: comparatorDesc, },
  ], []);

  const handleGetRowId = useCallback((params) => params.data.GroupID, []);

  const Input = styled('input')({
    display: 'none',
  });

  return (
    <React.Fragment>
      <CssBaseline />
      <Dialog
        fullWidth
        maxWidth="sm"
        open={open}
        // onClose={handleCloseClick}
        aria-describedby="add-user-dialog-description"

      >
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <MsgDialog
          open={showError}
          title="Error"
          msgText={errMsg}
          onClose={() => setShowError(false)}
        />

        <SelMemberDialog
          open={openAddUserDialog}
          disableUserTab
          onClose={() => { setOpenAddUserDialog(false) }}
          members={[]}
          groups={allUserGroups}
          onSelect={handleSelectAddUsers}
        />

        <DialogTitle>
          {!editMode &&
            `New User`
          }
          {editMode &&
            `Edit User`
          }
        </DialogTitle>
        <DialogContent>

          <Box sx={{ display: 'flex', flexDirection: 'column', mt: 1 }} component="form" onSubmit={handleSubmit(onSubmit)} >
            <Grid container spacing={1}  >

              <Grid item xs={6}>
                <Controller
                  name="userID"
                  control={control}
                  render={({ field }) =>
                    <TextField
                      required
                      label="User ID"
                      variant={!editMode && !isDomainUser ? "standard" : "filled"}
                      size="small"
                      fullWidth
                      {...field}

                      InputProps={{ readOnly: (!editMode && !isDomainUser ? false : true), }}
                      InputLabelProps={{ shrink: true, }}
                    />}
                />
              </Grid>

              {isDomainUser &&
                <Grid item xs={6}>
                  <Controller
                    name="domain"
                    control={control}
                    render={({ field }) =>
                      <TextField
                        label="Domain"
                        variant="filled"
                        size="small"
                        fullWidth
                        {...field}

                        InputProps={{ readOnly: true, }}
                        InputLabelProps={{ shrink: true, }}
                      />}
                  />
                </Grid>
              }
              {!isDomainUser &&
                <Grid item xs={6} />
              }


              {!isDomainUser &&
                <React.Fragment>
                  <Grid item xs={12}>
                    <Controller
                      name="pwd"
                      control={control}
                      render={({ field }) =>
                        <TextField
                          {...field}
                          required
                          variant="standard"
                          size="small"
                          fullWidth
                          label="Password"
                          type='password'

                          InputLabelProps={{ shrink: true, }}
                        />
                      }
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Controller
                      name="confirmPwd"
                      control={control}
                      render={({ field }) =>
                        <TextField
                          {...field}
                          required
                          variant="standard"
                          size="small"
                          fullWidth
                          label="Confirm Password"
                          type='password'

                          InputLabelProps={{ shrink: true, }}
                        />
                      }
                    />
                  </Grid>

                </React.Fragment>
              }



              <Grid item xs={6}>
                <Controller
                  name="name"
                  control={control}
                  render={({ field }) =>
                    <TextField
                      required
                      label="Name"
                      variant="standard"
                      size="small"
                      fullWidth
                      {...field}

                      InputLabelProps={{ shrink: true, }}
                    />}
                />
              </Grid>

              <Grid item xs={6}>
                <Controller
                  name="desc"
                  control={control}
                  render={({ field }) =>
                    <TextField
                      label="Description"
                      variant="standard"
                      size="small"
                      fullWidth
                      {...field}

                      InputLabelProps={{ shrink: true, }}
                    />}
                />
              </Grid>

              <Grid item xs={6}>
                <Controller
                  name="email"
                  control={control}
                  render={({ field }) =>
                    <TextField
                      label="Email"
                      variant="standard"
                      size="small"
                      fullWidth
                      {...field}

                      InputLabelProps={{ shrink: true, }}
                    />}
                />
              </Grid>

              <Grid item xs={6}>
                <Controller
                  name="deptCode"
                  control={control}
                  render={({ field }) =>
                    <TextField
                      label="Department"
                      variant="standard"
                      size="small"
                      fullWidth
                      {...field}
                      select
                      InputLabelProps={{ shrink: true, }}
                    >
                      {depts.map((d) => (
                        <MenuItem key={d.DeptCode} value={d.DeptCode}>
                          {d.DeptName}
                        </MenuItem>
                      ))}
                    </TextField>
                  }
                />
              </Grid>

              <Grid item xs={4}>
                <Controller
                  name="dataAdmin"
                  control={control}
                  render={({ field }) =>
                    <FormControl component="fieldset">
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              {...field}
                              checked={field.value}
                              onChange={(e) => field.onChange(e.target.checked)}
                            />}
                          label="Data Admin"
                          {...field}
                        />
                      </FormGroup>
                    </FormControl>
                  }
                />
              </Grid>

              <Grid item xs={4}>
                <Controller
                  name="securityAdmin"
                  control={control}
                  render={({ field }) =>
                    <FormControl component="fieldset">
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              {...field}
                              checked={field.value}
                              onChange={(e) => field.onChange(e.target.checked)}
                            />}
                          label="Security Admin"
                          {...field}
                        />
                      </FormGroup>
                    </FormControl>
                  }
                />
              </Grid>

              <Grid item xs={4}>
                <Controller
                  name="disabled"
                  control={control}
                  render={({ field }) =>
                    <FormControl component="fieldset">
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              {...field}
                              checked={field.value}
                              onChange={(e) => field.onChange(e.target.checked)}
                            />}
                          label="Disabled"
                          {...field}
                        />
                      </FormGroup>
                    </FormControl>
                  }
                />
              </Grid>
              <Grid item xs={12} >
                <Typography variant="h6" >
                  Edit User Group
                </Typography >

              </Grid>
              <Grid item xs={12} >
                <Button
                  startIcon={<PersonAddAlt1Icon />}
                  onClick={handleAddByUser}
                >
                  Add
                </Button>

                <Button
                  startIcon={<PersonRemoveIcon />}
                  disabled={selectedRecs.length == 0}
                  onClick={handleRemove}
                >
                  Remove
                </Button>
              </Grid>

              <Grid item xs={12} sx={{ height: '240px' }}>

                <div className="ag-theme-material" style={{ width: '100%', height: '100%', bgcolor: 'yellow' }}>
                  <AgGridReact

                    rowData={groups}

                    defaultColDef={{
                      width: 100,
                      resizable: true,
                      sortable: true,
                      suppressMovable: true,
                    }}
                    columnDefs={columnDefs}
                    headerHeight={40}

                    suppressNoRowsOverlay

                    rowSelection="multiple"
                    rowMultiSelectWithClick

                    onSelectionChanged={onSelectionChanged}

                    getRowId={handleGetRowId}
                  />
                </div>
              </Grid>

            </Grid>

            <Button type="submit" ref={submitBtnRef} sx={{ display: "none" }} variant="contained" >Submit</Button>

          </Box>



        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseClick}>Cancel</Button>
          <Button variant="contained" onClick={handleFormSubmit} >Submit</Button>
        </DialogActions>
      </Dialog>

    </React.Fragment>

  );
}

UserAddDialog.propTypes = {
  sysID: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onUpdated: PropTypes.func,
  editMode: PropTypes.bool,
  userInfo: PropTypes.object,
  isDomainUser: PropTypes.bool,
};


